import React from 'react';
import PropTypes from 'prop-types';
import { Link as SharedLink } from 'react-router-dom';
import { convertOptions } from './shared';

export const Link = props => <SharedLink {...props} to={convertOptions(props.to)} />;

Link.propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
};
